import { Card, Datepicker, ListGroup, ListGroupItem, WeekStart } from 'flowbite-react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { QueryResult } from '../../components/Alerts.tsx';
import { useBuildingContext } from '../../components/BuildingContext.tsx';
import ProtectedRoute from '../../components/ProtectedRoute.tsx';
import RequiresBuilding from '../../components/RequiresBuilding.tsx';
import RequiresFeature, { Features } from '../../components/RequiresFeature.tsx';
import { useAppDispatch, useAppSelector } from '../../lib/hooks.ts';
import { selectDate } from '../../lib/model/date/dateSlice.ts';
import { useGetIllegalParkingReportForBuildingQuery } from '../../lib/model/kantoordagApi.ts';

export default function ParkingReport () {
    return (
        <RequiresBuilding>
          <ParkingReportInternal/>
        </RequiresBuilding>
    )
}

function ParkingReportInternal() {
    const dispatch = useAppDispatch()
    const selectedBuilding = useBuildingContext();
    const date = DateTime.fromISO(useAppSelector(state => state.date.date))
    const { t, i18n } = useTranslation("parking-illegal");

    const parkingReportQuery = useGetIllegalParkingReportForBuildingQuery({
        datum: date.toISODate()!,
        building: selectedBuilding.name
    })

    function dateChanged(date: Date | null) {
        if (date) {
            dispatch(selectDate(DateTime.fromJSDate(date)))
        }
    }

    function illegalUsers(): string[] {
        return parkingReportQuery
                .data
                ?.report[selectedBuilding.name]
                .days
                .flatMap(day => day.illegalParkingsBy)
            ?? []
    }

    return (
        <ProtectedRoute authenticated roles={"ADMIN"}>
            <RequiresFeature feature={Features.PARKING}>
            <Datepicker onChange={dateChanged}
                        language={i18n.language}
                        className={"w-full"}
                        weekStart={WeekStart.Monday}
                        value={date.toJSDate()}/>
            <Card>
                <QueryResult query={parkingReportQuery} message={t("loading_failed")}>
                    {
                        parkingReportQuery.data?.report[selectedBuilding.name]?.days?.length == 0 ?
                            <span>
                                {t("no_illegal_parkings_found")}
                            </span>
                            : null
                    }

                    <ListGroup>
                    {
                        illegalUsers().map(user =>
                            (
                                <ListGroupItem>
                                    {user}
                                </ListGroupItem>
                            )
                        )
                    }
                    </ListGroup>

                </QueryResult>
            </Card>
            </RequiresFeature>
        </ProtectedRoute>
    )
}